module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/main-small-338537f7c8f5e9cb45847163de1793b3.svg";